export default "__VITE_ASSET__BZWAYEtR__"